import { render, staticRenderFns } from "./deposit-description-column.vue?vue&type=template&id=314a3060&scoped=true"
import script from "./deposit-description-column.vue?vue&type=script&lang=js"
export * from "./deposit-description-column.vue?vue&type=script&lang=js"
import style0 from "./deposit-description-column.vue?vue&type=style&index=0&id=314a3060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a3060",
  null
  
)

export default component.exports